<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="nav-container">
        <div class="nav-logo">
          <img src="./assets/feiya-logo.png" alt="常州非亚软件服务有限公司" class="logo-img">
          <span class="company-name">常州非亚软件服务有限公司</span>
        </div>
        <ul class="nav-menu">
          <li class="nav-item">
            <a href="#home" class="nav-links">首页</a>
          </li>
          <li class="nav-item">
            <a href="#services" class="nav-links">服务项目</a>
          </li>
          <li class="nav-item">
            <a href="#solutions" class="nav-links">解决方案</a>
          </li>
          <li class="nav-item">
            <a href="#about" class="nav-links">关于我们</a>
          </li>
          <li class="nav-item">
            <a href="#contact" class="nav-links">联系我们</a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 主页横幅 -->
    <section id="home" class="hero">
      <div class="hero-content">
        <div class="hero-logo">
          <img src="./assets/feiya-logo.png" alt="常州非亚软件服务有限公司" class="hero-logo-img">
        </div>
        <h1 class="hero-title">专业企业软件解决方案</h1>
        <p class="hero-description">
          常州非亚软件服务有限公司致力于为企业提供全方位的软件开发服务，
          包括ERP、MES、SRM、OA等系统的定制开发与实施
        </p>
        <div class="hero-buttons">
          <a href="#contact" class="btn btn-primary">立即咨询</a>
          <a href="#services" class="btn btn-secondary">了解服务</a>
        </div>
      </div>
    </section>

    <!-- 服务项目 -->
    <section id="services" class="services">
      <div class="container">
        <h2 class="section-title">我们的服务</h2>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">📊</div>
            <h3>ERP系统</h3>
            <p>企业资源计划系统，整合企业各部门资源，提升管理效率</p>
          </div>
          <div class="service-card">
            <div class="service-icon">⚙️</div>
            <h3>MES系统</h3>
            <p>制造执行系统，实现生产过程的数字化管理和控制</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🤝</div>
            <h3>SRM系统</h3>
            <p>供应商关系管理系统，优化供应链管理流程</p>
          </div>
          <div class="service-card">
            <div class="service-icon">💼</div>
            <h3>OA系统</h3>
            <p>办公自动化系统，提升企业内部协作和办公效率</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案 -->
    <section id="solutions" class="solutions">
      <div class="container">
        <h2 class="section-title">解决方案</h2>
        <div class="solutions-content">
          <div class="solution-item">
            <h3>制造业数字化转型</h3>
            <p>为制造企业提供从生产计划到质量管控的全流程数字化解决方案</p>
          </div>
          <div class="solution-item">
            <h3>企业管理信息化</h3>
            <p>构建集成化的企业管理平台，实现业务流程标准化和自动化</p>
          </div>
          <div class="solution-item">
            <h3>供应链协同管理</h3>
            <p>打通上下游供应链，实现采购、库存、销售的协同管理</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <div class="about-content">
          <p>
            常州非亚软件服务有限公司是一家专业的企业软件开发服务商，
            专注于为各行各业的企业客户提供定制化的软件解决方案。
            我们拥有丰富的项目实施经验和专业的技术团队，
            致力于通过信息化手段帮助企业提升管理效率和竞争优势。
          </p>
          <div class="company-info">
            <div class="info-item">
              <strong>服务理念：</strong>专业、高效、创新、共赢
            </div>
            <div class="info-item">
              <strong>技术优势：</strong>多年企业软件开发经验，成熟的技术架构
            </div>
            <div class="info-item">
              <strong>服务承诺：</strong>7x24小时技术支持，快速响应客户需求
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-info">
          <div class="contact-item">
            <h3>📞 联系电话</h3>
            <p>15161167116</p>
          </div>
          <div class="contact-item">
            <h3>🏢 公司名称</h3>
            <p>常州非亚软件服务有限公司</p>
          </div>
          <div class="contact-item">
            <h3>💡 主营业务</h3>
            <p>企业ERP、MES、SRM、OA等软件的开发服务及解决方案</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>&copy; 2024 常州非亚软件服务有限公司 版权所有</p>
        <p>备案号：苏ICP备2025202558号</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: #333;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏 */
.navbar {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.nav-logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 40px;
  width: auto;
  margin-right: 10px;
}

.company-name {
  color: #2c5aa0;
  font-size: 18px;
  font-weight: bold;
}

.nav-menu {
  display: flex;
  list-style: none;
}

.nav-item {
  margin-left: 30px;
}

.nav-links {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links:hover {
  color: #2c5aa0;
}

/* 主页横幅 */
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 150px 0 100px;
  text-align: center;
  margin-top: 70px;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-logo {
  text-align: center;
  margin-bottom: 30px;
}

.hero-logo-img {
  height: 120px;
  width: auto;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
}

.hero-title {
  font-size: 3rem;
  margin-bottom: 20px;
  font-weight: bold;
}

.hero-description {
  font-size: 1.2rem;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.8;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  display: inline-block;
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 600;
  transition: all 0.3s;
}

.btn-primary {
  background: #ff6b6b;
  color: white;
}

.btn-primary:hover {
  background: #ff5252;
  transform: translateY(-2px);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: white;
  color: #667eea;
}

/* 通用区块样式 */
.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 60px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: #2c5aa0;
}

/* 服务项目 */
.services {
  padding: 100px 0;
  background: #f8f9fa;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  padding: 40px 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.service-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 15px;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

/* 解决方案 */
.solutions {
  padding: 100px 0;
}

.solutions-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.solution-item {
  padding: 30px;
  border-left: 4px solid #2c5aa0;
  background: #f8f9fa;
  border-radius: 5px;
}

.solution-item h3 {
  color: #2c5aa0;
  font-size: 1.3rem;
  margin-bottom: 15px;
}

.solution-item p {
  color: #666;
  line-height: 1.6;
}

/* 关于我们 */
.about {
  padding: 100px 0;
  background: #f8f9fa;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.about-content > p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 40px;
  color: #555;
}

.company-info {
  display: grid;
  gap: 20px;
  text-align: left;
}

.info-item {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.info-item strong {
  color: #2c5aa0;
}

/* 联系我们 */
.contact {
  padding: 100px 0;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  text-align: center;
}

.contact-item {
  padding: 30px;
  background: #f8f9fa;
  border-radius: 10px;
}

.contact-item h3 {
  color: #2c5aa0;
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.contact-item p {
  font-size: 1.1rem;
  color: #555;
}

/* 页脚 */
.footer {
  background: #333;
  color: white;
  text-align: center;
  padding: 30px 0;
}

.footer p {
  margin-bottom: 5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    height: auto;
    padding: 20px;
  }
  
  .nav-menu {
    margin-top: 20px;
  }
  
  .nav-item {
    margin: 0 15px;
  }
  
  .hero {
    padding: 120px 0 80px;
    margin-top: 120px;
  }
  
  .hero-logo-img {
    height: 80px;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .company-name {
    font-size: 14px;
  }
  
  .logo-img {
    height: 30px;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
  }
  
  .solutions-content {
    grid-template-columns: 1fr;
  }
  
  .contact-info {
    grid-template-columns: 1fr;
  }
}
</style>
